import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import StartPage from "./StartPage";
import ConnectedPage from "./ConnectedPage";
import SuccessPage from "./SuccessPage";
import ReportsPage from "./ReportsPage";
import ReportDetailPage from "./ReportDetailPage";

/**
 * Route map.
 *
 * /          → ConnectedPage (the app's real homepage). Unauthenticated
 *              visitors get bounced to /start by the component itself, which
 *              keeps the ?token=... hydration path for post-OAuth redirects.
 * /start     → Google sign-in.
 * /connected → same page as /, kept so the OAuth callback URL keeps working.
 * /success   → post-payment confirmation.
 * /reports   → protected list of the user's reports.
 */
export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<ConnectedPage />} />
      <Route path="/connected" element={<ConnectedPage />} />
      <Route path="/start" element={<StartPage />} />
      <Route path="/success" element={<SuccessPage />} />

      <Route path="/login" element={<Navigate to="/start" replace />} />
      <Route path="/signup" element={<Navigate to="/start" replace />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/:token" element={<ReportDetailPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
